var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.showHead)?_c('div',{class:(_vm.prefixCardClass + "-header"),style:(_vm.headerStyle)},[_vm._t("head")],2):_vm._e(),_vm._v(" "),_c('div',{class:(_vm.prefixCardClass + "-block"),style:(_vm.contentStyle)},[_vm._t("default")],2),_vm._v(" "),(_vm.showFooter)?_c('div',{class:(_vm.prefixCardClass + "-footer"),style:(_vm.footerStyle)},[_vm._t("foot")],2):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58ed7004","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/card/card.vue
// module id = 624
// module chunks = 0 1 58